import { Award, Building, Calendar, Call, Car, Coin1, Driving, Location, SearchNormal1, Tag2, Verify, Wallet, Wallet3 } from "iconsax-react";
import { Autoplay, Navigation, Pagination, Thumbs } from "swiper/modules";
import { ExperienceCarList, ExperienceItem, NavType, WorkList } from "../../types/HomeDemo";
import { AmenitiesList, ContactBoxList } from "../../types/CommonComponents";

export const HomeTabData: NavType[] = [
  {
    id: 1,
    icon: <SearchNormal1 className="iconsax" />,
    label: "Search",
    inputLabel: "Enter Keyword...",
    dropdownMenu: [
      { title: "City,Locality", icon: <i className="ri-map-pin-line" /> },
      { title: "Area (like a Salmina)", icon: <i className="ri-map-pin-4-line" /> },
      { title: "Project or Builder name", icon: <i className="ri-building-4-line" /> },
    ],
  },
  {
    id: 2,
    icon: <Location className="iconsax" />,
    label: "Location",
    inputLabel: "Enter Location",
    dropdownMenu: [{ title: "Apartment" }, { title: "Kansas City" }, { title: "Santiago" }, { title: "Lisbon" }, { title: "Los Angeles" }, { title: "Sydney" }, { title: "Beijing" }],
  },
  {
    id: 3,
    icon: <Calendar className="iconsax" />,
    label: "Pick up Date",
    inputLabel: "Choose your Date",
  },
  {
    id: 4,
    icon: <Calendar className="iconsax" />,
    label: "Pick off Date",
    inputLabel: "Choose your Date",
  },
  {
    id: 5,
    icon: <Car className="iconsax" />,
    label: "Car Type",
    inputLabel: "Enter Car Type",
    dropdownMenu: [{ title: "Hatchback" }, { title: "SUV" }, { title: "Convertible" }, { title: "Sedan" }, { title: "Crossover" }],
  },
  {
    id: 6,
    icon: <Wallet className="iconsax" />,
    label: "Price",
    inputLabel: "Enter Your Price",
  },
  {
    id: 7,
    icon: <Building className="iconsax" />,
    label: "All Categories",
    inputLabel: "Enter Category Type",
    dropdownMenu: [{ title: "Education" }, { title: "Law & government" }, { title: "Arts" }, { title: "Construction" }, { title: "Finance" }, { title: "Technology" }, { title: "Communications" }, { title: "Health care" }],
  },
  {
    id: 8,
    icon: <Wallet className="iconsax" />,
    label: "Job Type",
    inputLabel: "Enter Job Type",
    dropdownMenu: [{ title: "Freelance" }, { title: "Full Time" }, { title: "Internship" }, { title: "Part Time" }],
  },
  {
    id: 9,
    icon: <Wallet className="iconsax" />,
    label: "Salary",
    inputLabel: "Enter Salary",
  },
  {
    id: 10,
    icon: <Building className="iconsax" />,
    label: "Property Type",
    inputLabel: "Enter Property Type",
    dropdownMenu: [{ title: "Apartment" }, { title: "House" }, { title: "Vila" }, { title: "Office" }, { title: "Farmhouse" }],
  },
  {
    id: 11,
    icon: <Wallet className="iconsax" />,
    label: "Price",
    inputLabel: "Enter Your Price",
  },
];

export const CategoriesSettingData = {
  slidesPerView: 4.5,
  spaceBetween: 40,
  // autoplay: { delay: 2000, disableOnInteraction: false },
  modules: [Autoplay, Navigation],
  loop: true,
  speed: 500,
  navigation: {
    nextEl: ".car2-category-next",
    prevEl: ".car2-category-prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 1.2,
      spaceBetween: 10,
    },
    420: {
      slidesPerView: 2.2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 3.8,
      spaceBetween: 20,
    },
    992: {
      slidesPerView: 4.5,
      spaceBetween: 30,
    },
    1400: {
      slidesPerView: 5.4,
      spaceBetween: 40,
    },
  },
};

export const CategoriesContentData: string = "Explore our range of compact cars, luxury sedans, rugged SUVs, and reliable trucks to find your ideal vehicle today.";

export const MostSearchedContentData: string = "Explore this year's hottest cars! From sports cars to family SUVs, discover the most searched models and why they're trending.";

export const ServiceContentData: string = "Enjoy outstanding, one-stop automotive care.";

export const ServiceData: ContactBoxList[] = [
  // { icon: <Driving className="iconsax" />, title: "Car for rent", text: "Rent a car for flexible travel and the freedom to explore at your own pace." },
  { icon: <Tag2 className="iconsax" />, title: "Buy your Car", text: "Reliable car for sale: low mileage, excellent condition, great value—test drive now!", url: 'inventory' },
  { icon: <Car className="iconsax" />, title: "Sell your car", text: "We make selling your car fast and hassle-free with inspection, pricing, and paperwork handled for you.", url: 'sell-your-car' },
  { icon: <Call className="iconsax" />, title: "JPJ Services", text: "We provide vehicle registration, road tax, and license renewal services quickly and efficiently.", url: 'jpj' },
  { icon: <Verify className="iconsax" />, title: "Consign With Us", text: "Partner with us for professional marketing and sales. Our experts handle negotiations, viewing, and close the deal to get you the best price, hassle-free.", url: 'sell-your-car' },
];

export const WorkContentData: string = "Selling your car should be easy. Our process gets you the best offer fast and hassle free. Here’s how it works:";

export const WorkData: WorkList[] = [
  { 
    icon: 'other/schedule.png', 
    // icon: <Location className="iconsax" />, 
    title: 'Book an Appointment',
    text: "It only takes 2 minutes to book your car inspection appointment.", 
    duration: 300 
  },
  { 
    icon: 'other/checklist.png', 
    // icon: <Calendar className="iconsax" />, 
    title: 'Comprehensive 175-Point Check',
    text: "Our experts will complete a detailed inspection in just 30 minutes. appointment.", 
    duration: 500, svg: true 
  },
  { 
    icon: 'other/rental-car.png', 
    // icon: <Verify className="iconsax" />, 
    title: 'Sell Your Car',
    text: "Get an on the spot offer from our team of professionals, quick, fair, and straightforward. Book your appointment today.", 
    duration: 700,
  },
  { 
    icon: 'other/payment.png', 
    // icon: <Verify className="iconsax" />, 
    title: 'Get Paid Instandly without delay',
    text: "Receive payment quickly and let us handle all the paperwork hassle-free. Book your appointment today.", 
    duration: 900,
    svg: true 
  },
];

export const ExperienceContentData: string = "Discover why our customers trust us to make their car buying journey smooth and enjoyable.";

export const ServiceContent: string = "We provide free consultation to help you find a tenant for your new house.";

export const ExperienceData: ExperienceItem[][] = [
  [
    { icon: <Tag2 className="iconsax" />, text: 'Buy or sell with confi- dence—every vehicle goes through a verified process for peace of mind.' }, 
    { icon: <Wallet3 className="iconsax" />, text: 'Sell your car easily with transparent valuation and hassle-free process.' }, 
    { icon: <Call className="iconsax" />, text: "We're ready to assist you in buying or selling your car with no hidden charges." }
  ], [{ image: true }], 
  [
    { icon: <Award className="iconsax" />, text: 'We ensure all deals are trans- parent and protect both buyer and seller.' }, 
    { icon: <Coin1 className="iconsax" />, text: 'We evaluate your car fairly to help you get the best value.' }, 
    { icon: <Car className="iconsax" />, text: 'Choose from a variety of well-maintained vehicles to suit your needs and budget.' }
  ]
];

export const ExperienceCarData: ExperienceCarList[] = [
  { icon: "car/experience/1.svg", label: "Horsepower", value: "310" },
  { icon: "car/experience/2.svg", label: "Starting at", value: "$44,870" },
  { icon: "car/experience/3.svg", label: "MPG City/Hwy", value: "20/30" },
  { icon: "car/experience/4.svg", label: "Fuel (gal)", value: "15 cu.ft." },
  { icon: "car/experience/5.svg", label: "Seats up to", value: "5 Seats" },
  { icon: "car/experience/6.svg", label: "Drivetrain", value: "AWD" },
  { icon: "car/experience/7.svg", label: "Acceleration", value: "5.9 Seconds" },
  { icon: "car/experience/8.svg", label: "Length (in)", value: "180.6" },
];

export const AboutContentData: string = "CC Autoworld is the leading used car dealer in Petaling Jaya (PJ), specializing in offering quality, roadworthy used cars for sale in PJ at competitive prices. Whether you’re searching for a reliable pre-owned hatchback, SUV, or sedan, or looking to sell or trade in your existing vehicle, we provide a hassle free experience. Our fast and transparent car inspections, fair trade in values, instant payment, and fully managed paperwork ensure that your journey is smooth from start to finish. With a wide range of affordable used cars for sale in Petaling Jaya and ongoing promotions, customers can easily find the right vehicle that meets their lifestyle and budget.";

export const LuxuryCarContentData: string = "Trusted by hundreds across PJ and the Klang Valley, CC Autoworld delivers honest service, excellent customer satisfaction, and long term value making us a top choice for used car buyers and sellers in Malaysia. As one of the top rated used car dealers in PJ, our dedicated team ensures every transaction is transparent and customer focused. Whether you’re upgrading to a family car, downsizing, or buying your first vehicle, CC Autoworld stands out with competitive pricing, quality assurance, and expert support helping you buy or sell your used car in PJ with complete confidence.";

export const AboutData: AmenitiesList[] = [
  { image: "car2/1.jpeg", title: "Car Certified" },
  { image: "car2/2.jpeg", title: "Price Guarantee" },
  { image: "car2/3.jpeg", title: "Quick and Easy Transaction" },
];

export const TestimonialsContentData: string = "Discover the appropriate property that is most acceptable for you, ranging from houses";

export const TestimonialsSwiperSetting = {
  navigation: {
    prevEl: ".swiper-button-prev",
    nextEl: ".swiper-button-next",
  },
  modules: [Navigation],
  slidesPerView: 3,
  className: "car-testimonials-slider",
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 2,
    },
    1200: {
      slidesPerView: 3,
    },
  },
};

export const ProductSwiperSetting = {
  navigation: true,
  modules: [Navigation],
  loop: false,
  className: "property-image-slider",
};

export const OfferContentData: string = "Get exclusive offers on high-end residences and coveted cars! Our incredible deals will help you save a tonne of money and improve your lifestyle.";

export const OfferSwiperSetting = {
  slidesPerView: 4,
  spaceBetween: 30,
  speed: 2000,
  autoplay: { delay: 2500, disableOnInteraction: false },
  modules: [Autoplay],
  breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 14,
    },
    350: {
      slidesPerView: 1.5,
      spaceBetween: 14,
    },
    525: {
      slidesPerView: 2,
      spaceBetween: 14,
    },
    768: {
      slidesPerView: 2.5,
      spaceBetween: 14,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 14,
    },
    1150: {
      slidesPerView: 3.5,
      spaceBetween: 24,
    },
    1700: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  },
};

export const CarSlider = {
  speed: 600,
  spaceBetween: 10,
  freeMode: true,
  modules: [Thumbs, Autoplay, Navigation, Pagination],
  autoplay: { delay: 3000, disableOnInteraction: false },
  pagination: { clickable: true },
};

export const CarSliderNav = {
  slidesPerView: 3,
  watchSlidesProgress: true,
  breakpoints: {
    0: {
      slidesPerView: 2,
    },
    640: {
      slidesPerView: 3,
    },
  },
};
